import React from 'react'
import PropTypes from 'prop-types'
import styles from './Footer.module.scss'

const Footer = () => (
  <div className={styles.Footer} data-testid="Footer">
    <footer>
      <div className="footer-pad">
        <div className="footer-left">
          <span>
            Trust Square Service AG - &copy; {new Date().getFullYear()} All Rights Reserved
          </span>
        </div>
        <div className="footer-right">
          <a href="mailto:ir@trustsquare.com">Contact: ir@trustsquare.com</a>
        </div>
      </div>
    </footer>
  </div>
)

Footer.propTypes = {}

Footer.defaultProps = {}

export default Footer
